import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Stepper,
  Step,
  StepLabel,
  LinearProgress
} from "@material-ui/core";

export type Props = {
  open: boolean;
};

export const ContractUploaderDialog = (props: Props) => {
  const counter = useRef(0);
  const handleRef = useRef<NodeJS.Timeout>(null);
  const [_, forceUpdate] = useState(null);

  useEffect(() => {
    if (props.open) {
      counter.current = 0;
      const handle = setInterval(() => {
        counter.current++;
        forceUpdate(counter.current);
      }, 500);
      handleRef.current = handle;
    } else {
      handleRef?.current && clearInterval(handleRef.current);
    }
  }, [props.open]);

  return (
    <Dialog open={props.open} maxWidth="md" fullWidth>
      <DialogContent>
        <Typography variant="subtitle1" style={{ marginBottom: 16, fontWeight: "bold" }}>
          Publishing contract..
        </Typography>

        <Stepper>
          <Step key="1" completed={counter.current > 0}>
            <StepLabel>Creating contract</StepLabel>
          </Step>

          <Step key="2" completed={counter.current > 3}>
            <StepLabel>Converting to PDF</StepLabel>
          </Step>

          <Step key="3" completed={counter.current > 6}>
            <StepLabel>Sending to OneFlow</StepLabel>
          </Step>
        </Stepper>

        <LinearProgress />
      </DialogContent>
    </Dialog>
  );
};
